export class QrefOkwed2Model {
  code: string;
  name: string;

  constructor() {
  }
}

